import render from '@zr/components/bootstrapper';
import JobResults, { JobResultsProps } from './job-results/JobResults';
import { JobResult } from './job-results/types.d';

declare const zr: {
  page: {
    model: {
      jobList: Array<JobResult>;
      jobCount: number;
      page: number;
      maxPages: number;
      placementID: string;
      superSetID: string;
      isEligibleForOneClickApply: boolean;
    };
  };
};

export const initializeJobResults = (): void => {
  const props: JobResultsProps = {
    jobList: zr.page.model.jobList,
    jobCount: zr.page.model.jobCount,
    currentPage: zr.page.model.page,
    maxPages: zr.page.model.maxPages,
    pageSize: 20,
    placementId: zr.page.model.placementID,
    impressionSuperSetId: zr.page.model.superSetID,
    isEligibleForOneClickApply: zr.page.model.isEligibleForOneClickApply,
  };
  const rootElement = document.getElementById('react-job-results-root');
  if (rootElement) {
    render(JobResults, rootElement, props); // eslint-disable-line
  }
};
